<script setup lang="ts">
import { cn } from 'cn'
import { computed, type HTMLAttributes } from 'vue'
import { SelectGroup, type SelectGroupProps } from 'reka-ui'

import { selectClasses } from './variants'

const props = defineProps<SelectGroupProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <SelectGroup
    :class="cn(
      selectClasses.group,
      'w-full',
      props.class,
    )"
    v-bind="delegatedProps"
  >
    <slot />
  </SelectGroup>
</template>
